import dayjs, { type Dayjs } from "@eisox/dayjs";

/** Ten years is the battery endpoint's own cap on how far back it searches. */
const VALVE_HISTORY_LOOKBACK_YEARS = 10;

export const getValveHistoryMinDate = (now = dayjs()): Dayjs =>
  now.subtract(VALVE_HISTORY_LOOKBACK_YEARS, "year").startOf("day");
